import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconHomeRoundDoor: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="home-round-door"><path d="M14.1829 3.6403C12.8776 2.70584 11.1224 2.70584 9.81708 3.6403L4.56708 7.39882C3.58351 8.10297 3 9.23833 3 10.448V17.2499C3 19.321 4.67893 20.9999 6.75 20.9999H8.75C9.16421 20.9999 9.5 20.6641 9.5 20.2499V16.7499C9.5 15.3692 10.6193 14.2499 12 14.2499C13.3807 14.2499 14.5 15.3692 14.5 16.7499V20.2499C14.5 20.6641 14.8358 20.9999 15.25 20.9999H17.25C19.3211 20.9999 21 19.321 21 17.2499V10.448C21 9.23833 20.4165 8.10297 19.4329 7.39882L14.1829 3.6403Z" fill="currentColor"/></CentralIconBase>;
};

export default IconHomeRoundDoor;
